import styled from 'styled-components';

import { colors } from 'theme/theme';

import { ToggleSection } from './ToggleSection';

export const StyledForm = styled.div`
  ${ToggleSection} {
    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 1px;
      background: ${colors.selectionGrey};
    }

    &::before {
      top: 0;
    }

    &::after {
      bottom: 0;
    }
    & + ${ToggleSection} {
      &::before {
        opacity: 0;
      }
    }
    & + ${`*:not(${ToggleSection})`} {
      margin-top: 31px;
    }
  }
`;
